'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetContactForm = exports.submitContactForm = exports.processFailedPayments = exports.getPaymentDetails = exports.returnEmailSavedQuote = exports.emailSavedQuote = exports.returnQuoteNumber = exports.saveQuoteNumber = exports.updateLiveQuote = exports.pushApplicationData = exports.patchApplicant = exports.updateApplicant = exports.updateApplication = exports.makeApplicationPayment = exports.updateLiveApplication = exports.createApplicant = exports.createApplication = exports.updateApplicationData = exports.getCurrentApplication = exports.getApplicationConfirmation = exports.getApplicationQuote = exports.getRenewal = exports.getSavedQuote = exports.getFormConfiguration = exports.getAuthorization = exports.postContactFormComplete = exports.postContactFormInit = exports.EmailFailstatus = exports.EmailSentstatus = exports.setMailStatus = exports.setLoadingState = exports.getQuoteNumber = exports.patchUpdateApplicantComplete = exports.patchUpdateApplicantInit = exports.putUpdateApplicantComplete = exports.putUpdateApplicantInit = exports.putUpdateAppComplete = exports.putUpdateAppInit = exports.postMakePaymentComplete = exports.postMakePaymentInit = exports.postCreateApplicantComplete = exports.postCreateApplicantInit = exports.postCreateAppComplete = exports.postCreateAppInit = exports.processFailedPaymentsComplete = exports.processFailedPaymentsInit = exports.getFailedDetailsComplete = exports.getFailedDetailsInit = exports.getApplicationDataComplete = exports.getApplicationDataInit = exports.getConfirmationTextComplete = exports.getConfirmationTextInit = exports.getAppQuoteComplete = exports.getAppQuoteInit = exports.getSavedQuoteComplete = exports.getSavedQuoteInit = exports.getFormConfigComplete = exports.getFormConfigInit = exports.postAuthComplete = exports.postAuthInit = exports.resetQuote = exports.formError = exports.setNumPages = exports.forwardPage = exports.backPage = undefined;

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _string = require('lodash/string');

var _Constants = require('./Constants');

var Constants = _interopRequireWildcard(_Constants);

var _Methods = require('../requests/Methods');

var Methods = _interopRequireWildcard(_Methods);

var _handleError = require('../requests/handleError');

var _handleError2 = _interopRequireDefault(_handleError);

var _makeHeaders = require('../requests/makeHeaders');

var _makeHeaders2 = _interopRequireDefault(_makeHeaders);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Flux Standard Action object.
 * @typedef {Object} FSA
 */

/**
 * Generates an action creator. Adheres to Flux Standard Action (https://github.com/acdlite/flux-standard-action).
 * @param {String} type - Type of the action. Must be one of the defined action constants.
 * @returns {Function} Function which generates this action.
 */
var makeActionCreator = function makeActionCreator(type) {
  return function () {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    return {
      type: type,
      payload: payload,
      error: error,
      meta: meta
    };
  };
};

var backPage = exports.backPage = makeActionCreator(Constants.BACK_PAGE);
var forwardPage = exports.forwardPage = makeActionCreator(Constants.FORWARD_PAGE);
var setNumPages = exports.setNumPages = makeActionCreator(Constants.SET_NUM_PAGES);

var formError = exports.formError = makeActionCreator(Constants.FORM_ERROR);

var resetQuote = exports.resetQuote = makeActionCreator(Constants.RESET_QUOTE);

/**
 * Async action creators
 */

// auth API
var postAuthInit = exports.postAuthInit = makeActionCreator(Constants.POST_AUTH_INIT);
var postAuthComplete = exports.postAuthComplete = makeActionCreator(Constants.POST_AUTH_COMPLETE);

// GET /configuration/{source}/form
var getFormConfigInit = exports.getFormConfigInit = makeActionCreator(Constants.GET_FORM_CONFIG_INIT);
var getFormConfigComplete = exports.getFormConfigComplete = makeActionCreator(Constants.GET_FORM_CONFIG_COMPLETE);

// GET /savedquote/{source}/{applicationId}
var getSavedQuoteInit = exports.getSavedQuoteInit = makeActionCreator(Constants.GET_SAVED_QUOTE_INIT);
var getSavedQuoteComplete = exports.getSavedQuoteComplete = makeActionCreator(Constants.GET_SAVED_QUOTE_COMPLETE);

// GET /quote/{source}/{applicationId}
var getAppQuoteInit = exports.getAppQuoteInit = makeActionCreator(Constants.GET_APP_QUOTE_INIT);
var getAppQuoteComplete = exports.getAppQuoteComplete = makeActionCreator(Constants.GET_APP_QUOTE_COMPLETE);

// GET /confirmation/{source}/{applicationId}
var getConfirmationTextInit = exports.getConfirmationTextInit = makeActionCreator(Constants.GET_CONFIRMATION_TEXT_INIT);
var getConfirmationTextComplete = exports.getConfirmationTextComplete = makeActionCreator(Constants.GET_CONFIRMATION_TEXT_COMPLETE);

// GET /policy/{source}/{policyNumber}
var getApplicationDataInit = exports.getApplicationDataInit = makeActionCreator(Constants.GET_APPLICATION_DATA_INIT);
var getApplicationDataComplete = exports.getApplicationDataComplete = makeActionCreator(Constants.GET_APPLICATION_DATA_COMPLETE);

// GET /get_failed_details/{paymentId}
var getFailedDetailsInit = exports.getFailedDetailsInit = makeActionCreator(Constants.GET_FAILED_DETAILS_INIT);
var getFailedDetailsComplete = exports.getFailedDetailsComplete = makeActionCreator(Constants.GET_FAILED_DETAILS_COMPLETE);

// POST /processFailedPayments/{applicationId}
var processFailedPaymentsInit = exports.processFailedPaymentsInit = makeActionCreator(Constants.PROCESS_FAILED_PAYMENTS_INIT);
var processFailedPaymentsComplete = exports.processFailedPaymentsComplete = makeActionCreator(Constants.PROCESS_FAILED_PAYMENTS_COMPLETE);

// POST /application/{source}
var postCreateAppInit = exports.postCreateAppInit = makeActionCreator(Constants.POST_CREATE_APP_INIT);
var postCreateAppComplete = exports.postCreateAppComplete = makeActionCreator(Constants.POST_CREATE_APP_COMPLETE);

// POST /applicant/{source}/{applicantId}
var postCreateApplicantInit = exports.postCreateApplicantInit = makeActionCreator(Constants.POST_CREATE_APPLICANT_INIT);
var postCreateApplicantComplete = exports.postCreateApplicantComplete = makeActionCreator(Constants.POST_CREATE_APPLICANT_COMPLETE);

// POST /payment/{source}/{applicationId}
var postMakePaymentInit = exports.postMakePaymentInit = makeActionCreator(Constants.POST_MAKE_PAYMENT_INIT);
var postMakePaymentComplete = exports.postMakePaymentComplete = makeActionCreator(Constants.POST_MAKE_PAYMENT_COMPLETE);

// PUT /application/{source}/{id}
var putUpdateAppInit = exports.putUpdateAppInit = makeActionCreator(Constants.PUT_UPDATE_APP_INIT);
var putUpdateAppComplete = exports.putUpdateAppComplete = makeActionCreator(Constants.PUT_UPDATE_APP_COMPLETE);

// PUT /applicant/{source}/{applicationId}/{id}
var putUpdateApplicantInit = exports.putUpdateApplicantInit = makeActionCreator(Constants.PUT_UPDATE_APPLICANT_INIT);
var putUpdateApplicantComplete = exports.putUpdateApplicantComplete = makeActionCreator(Constants.PUT_UPDATE_APPLICANT_COMPLETE);

// PATCH /applicant/{source}/{applicationId}/{id}
var patchUpdateApplicantInit = exports.patchUpdateApplicantInit = makeActionCreator(Constants.PATCH_UPDATE_APPLICANT_INIT);
var patchUpdateApplicantComplete = exports.patchUpdateApplicantComplete = makeActionCreator(Constants.PATCH_UPDATE_APPLICANT_COMPLETE);

var getQuoteNumber = exports.getQuoteNumber = makeActionCreator(Constants.GET_QUOTE_NUMBER);
var setLoadingState = exports.setLoadingState = makeActionCreator(Constants.SET_LOADING_TRUE);
var setMailStatus = exports.setMailStatus = makeActionCreator(Constants.SET_MAIL_STATUS);

var EmailSentstatus = exports.EmailSentstatus = makeActionCreator(Constants.EMAIL_SENT);
var EmailFailstatus = exports.EmailFailstatus = makeActionCreator(Constants.EMAIL_FAIL);

var postContactFormInit = exports.postContactFormInit = makeActionCreator(Constants.POST_CONTACT_FORM_INIT);
var postContactFormComplete = exports.postContactFormComplete = makeActionCreator(Constants.POST_CONTACT_FORM_COMPLETE);

/**
 * Generates an async thunk which dispatches actions for an HTTP request.
 * @param {Object} options - Options specifying how the thunk behaves.
 * @returns {Function} The thunk.
 */
var makeAsyncRequestDispatcher = function makeAsyncRequestDispatcher(options) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var response, errors;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(options.preRequestDispatch());
              _context.next = 3;
              return options.fetchResult();

            case 3:
              response = _context.sent;
              _context.prev = 4;
              _context.t0 = dispatch;
              _context.t1 = options;
              _context.next = 9;
              return (0, _handleError2.default)(response).json();

            case 9:
              _context.t2 = _context.sent;
              _context.t3 = _context.t1.postRequestDispatch.call(_context.t1, _context.t2, false);
              return _context.abrupt('return', (0, _context.t0)(_context.t3));

            case 14:
              _context.prev = 14;
              _context.t4 = _context['catch'](4);
              _context.next = 18;
              return response.json();

            case 18:
              errors = _context.sent;
              return _context.abrupt('return', dispatch(options.postRequestDispatch(errors, true)));

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[4, 14]]);
    }));

    return function (_x4) {
      return _ref.apply(this, arguments);
    };
  }();
};

/**
 * GET actions
 */

/**
 * Dispatches an action to get an authorization token from the API.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @returns {Function} A thunk.
 */
var getAuthorization = exports.getAuthorization = function getAuthorization(source, lang) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return postAuthInit({ source: source });
    },
    fetchResult: function fetchResult() {
      return Methods.post((0, _string.trimEnd)(_config2.default.auth_api, '/') + '/' + source, (0, _makeHeaders2.default)(lang));
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? postAuthComplete(payload, true) : postAuthComplete({ source: source, data: payload });
    }
  });
};

/**
 * Dispatches an action to get the form configuration for a source from the API.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @returns {Function} A thunk.
 */
var getFormConfiguration = exports.getFormConfiguration = function getFormConfiguration(source, lang, auth) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return getFormConfigInit({ source: source });
    },
    fetchResult: function fetchResult() {
      return Methods.get((0, _string.trimEnd)(_config2.default.api, '/') + '/configuration/' + source + '/form', (0, _makeHeaders2.default)(lang, auth));
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? getFormConfigComplete(payload, true) : getFormConfigComplete({ source: source, data: payload });
    }
  });
};

/**
 * Dispatches an action to get the form configuration for a source from the API.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @returns {Function} A thunk.
 */
var getSavedQuote = exports.getSavedQuote = function getSavedQuote(source, lang, auth, referenceId) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return getSavedQuoteInit({ source: source });
    },
    fetchResult: function fetchResult() {
      return Methods.get((0, _string.trimEnd)(_config2.default.api, '/') + '/savedquote/' + source + '/' + referenceId, (0, _makeHeaders2.default)(lang, auth));
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? getSavedQuoteComplete(payload, true) : getSavedQuoteComplete({ source: source, data: payload });
    }
  });
};

/**
 * Dispatches an action to get the form configuration for a source from the API.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @returns {Function} A thunk.
 */
var getRenewal = exports.getRenewal = function getRenewal(source, lang, auth, applicationId) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return getSavedQuoteInit({ source: source });
    },
    fetchResult: function fetchResult() {
      return Methods.get((0, _string.trimEnd)(_config2.default.api, '/') + '/application/' + source + '/' + applicationId, (0, _makeHeaders2.default)(lang, auth));
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? getSavedQuoteComplete(payload, true) : getSavedQuoteComplete({ source: source, data: payload });
    }
  });
};

/**
 * Dispatches an action to get the quote for an application from the API.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} applicationId - ID for the application.
 * @returns {Function} A thunk.
 */
var getApplicationQuote = exports.getApplicationQuote = function getApplicationQuote(source, lang, auth, applicationId) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return getAppQuoteInit({ source: source, applicationId: applicationId });
    },
    fetchResult: function fetchResult() {
      return Methods.get((0, _string.trimEnd)(_config2.default.api, '/') + '/quote/' + source + '/' + applicationId, (0, _makeHeaders2.default)(lang, auth));
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? getAppQuoteComplete(payload, true) : getAppQuoteComplete({ source: source, applicationId: applicationId, data: payload });
    }
  });
};

/**
 * Dispatches an action to get the confirmation text for an application from the API.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} applicationId - ID for the application.
 * @returns {Function} A thunk.
 */
var getApplicationConfirmation = exports.getApplicationConfirmation = function getApplicationConfirmation(source, lang, auth, applicationId) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return getConfirmationTextInit({ source: source, applicationId: applicationId });
    },
    fetchResult: function fetchResult() {
      return Methods.get((0, _string.trimEnd)(_config2.default.api, '/') + '/confirmation/' + source + '/' + applicationId + '/0', (0, _makeHeaders2.default)(lang, auth));
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? getConfirmationTextComplete(payload, true) : getConfirmationTextComplete({ source: source, applicationId: applicationId, data: payload });
    }
  });
};

/**
 * Dispatches an action to get the confirmation text for an application from the API.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} policyNumber - ID for the application.
 * @returns {Function} A thunk.
 */
var getCurrentApplication = exports.getCurrentApplication = function getCurrentApplication(product, lang, auth, policyNumber) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return getApplicationDataInit({ product: product, policyNumber: policyNumber });
    },
    fetchResult: function fetchResult() {
      return Methods.get((0, _string.trimEnd)(_config2.default.api, '/') + '/policy/' + product + '/' + policyNumber, (0, _makeHeaders2.default)(lang, auth));
    },
    postRequestDispatch: function postRequestDispatch(application, isError) {
      return isError ? resetQuote(application, true) : getApplicationDataComplete({ product: product, policyNumber: policyNumber, data: application });
    }
  });
};

var updateApplicationData = exports.updateApplicationData = function updateApplicationData(product, lang, auth, policyNumber) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', dispatch(getCurrentApplication(product, lang, auth, policyNumber)));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function (_x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }();
};

/**
 * POST actions
 */

/**
 * Dispatches an action to create a new application.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {Object} applicationData - Initial data for the application.
 * @returns {Function} A thunk.
 */
var createApplication = exports.createApplication = function createApplication(source, lang, auth, applicationData) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return postCreateAppInit({ source: source, applicationData: applicationData });
    },
    fetchResult: function fetchResult() {
      return Methods.post((0, _string.trimEnd)(_config2.default.api, '/') + '/application/' + source, (0, _makeHeaders2.default)(lang, auth), applicationData);
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? postCreateAppComplete(payload, true) : postCreateAppComplete({ source: source, data: payload });
    }
  });
};

/**
 * Dispatches an action to create new applicant data for an application.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} applicationId - ID of the application to update.
 * @param {Object} applicantData - Initial data for the applicant(s).
 * @returns {Function} A thunk.
 */
var createApplicant = exports.createApplicant = function createApplicant(source, lang, auth, applicationId, applicantData) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return postCreateApplicantInit({ source: source, applicantData: applicantData });
    },
    fetchResult: function fetchResult() {
      return Methods.post((0, _string.trimEnd)(_config2.default.api, '/') + '/applicant/' + source + '/' + applicationId, (0, _makeHeaders2.default)(lang, auth), applicantData);
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? postCreateApplicantComplete(payload, true) : postCreateApplicantComplete({ source: source, applicationId: applicationId, data: payload });
    }
  });
};

/**
 * Update the applicant for the renewal form dynamic changes.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} policyNumber - Policy Number of the application to get the data from.
 * @returns {Function} A thunk.
 */
var updateLiveApplication = exports.updateLiveApplication = function updateLiveApplication(product, lang, auth, policyNumber) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var response;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (getState().api.requestStatus.GET_APP_QUOTE) {
                _context3.next = 5;
                break;
              }

              _context3.next = 3;
              return dispatch(updateApplicationData(product, lang, auth, policyNumber));

            case 3:
              response = _context3.sent;
              return _context3.abrupt('return', response.error ? dispatch(resetQuote({ data: response.application })) : dispatch(getApplicationDataComplete({ product: product, policyNumber: policyNumber, data: response })));

            case 5:
              return _context3.abrupt('return', Promise.resolve());

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, undefined);
    }));

    return function (_x7, _x8) {
      return _ref3.apply(this, arguments);
    };
  }();
};

/**
 * Dispatches an action to make a payment for an application.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} applicationId - ID of the application to make a payment for.
 * @param {Object} paymentData - Data for the payment.
 * @returns {Function} A thunk.
 */
var makeApplicationPayment = exports.makeApplicationPayment = function makeApplicationPayment(source, lang, auth, applicationId, paymentData) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return postMakePaymentInit({ source: source });
    },
    fetchResult: function fetchResult() {
      return Methods.post((0, _string.trimEnd)(_config2.default.api, '/') + '/payment/' + source + '/' + applicationId, (0, _makeHeaders2.default)(lang, auth), paymentData);
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? postMakePaymentComplete(payload, true) : postMakePaymentComplete({ source: source, data: payload });
    }
  });
};

/**
 * PUT actions
 */

/**
 * Dispatches an action to update an existing application.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} applicationId - ID of the application to update.
 * @param {Object} applicationData - The new application data.
 * @returns {Function} A thunk.
 */
var updateApplication = exports.updateApplication = function updateApplication(source, lang, auth, applicationId, applicationData) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return putUpdateAppInit({ source: source, applicationId: applicationId, applicationData: applicationData });
    },
    fetchResult: function fetchResult() {
      return Methods.put((0, _string.trimEnd)(_config2.default.api, '/') + '/application/' + source + '/' + applicationId, (0, _makeHeaders2.default)(lang, auth), applicationData);
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? putUpdateAppComplete(payload, true) : postCreateAppComplete({ source: source, data: payload });
    }
  });
};

/**
 * Dispatches an action to update an existing applicant.
 * Note: this will use the PUT method for updating applicant information.
 * For the PATCH method, see {@link patchApplicant}.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} applicationId - ID of the application to update.
 * @param {Object} applicantData - The data to update the applicant with.
 * @returns {Function} A thunk.
 */
var updateApplicant = exports.updateApplicant = function updateApplicant(source, lang, auth, applicationId, applicantData) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return putUpdateApplicantInit({ source: source, applicationId: applicationId, applicantData: applicantData });
    },
    fetchResult: function fetchResult() {
      return Methods.put((0, _string.trimEnd)(_config2.default.api, '/') + '/applicant/' + source + '/' + applicationId, (0, _makeHeaders2.default)(lang, auth), applicantData);
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? putUpdateApplicantComplete(payload, true) : putUpdateApplicantComplete({ source: source, applicationId: applicationId, data: payload });
    }
  });
};

/**
 * PATCH actions
 */

/**
 * Dispatches an action to update an existing applicant.
 * Note: this will use the PATCH method for updating applicant information.
 * For the PUT method, see {@link updateApplicant}.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} applicationId - ID of the application to update.
 * @param {Object} applicantData - The data to update the applicant with.
 * @returns {Function} A thunk.
 */
var patchApplicant = exports.patchApplicant = function patchApplicant(source, lang, auth, applicationId, applicantData) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return patchUpdateApplicantInit({ source: source, applicationId: applicationId, applicantData: applicantData });
    },
    fetchResult: function fetchResult() {
      return Methods.patch((0, _string.trimEnd)(_config2.default.api, '/') + '/applicant/' + source + '/' + applicationId, (0, _makeHeaders2.default)(lang, auth), applicantData);
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? patchUpdateApplicantComplete(payload, true) : patchUpdateApplicantComplete({ source: source, applicationId: applicationId, data: payload });
    }
  });
};

/**
 * Convenience methods for combining some API requests.
 */

/**
 * Dispatches an action to update an application, or create it if it doesn't exist.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} applicationId - ID of the application to update. A new application will
 *                                 be created first if an empty value is given.
 * @param {Object} [applicationData=null] - Data to create an application with, if necessary.
 * @returns {Function} A thunk.
 */
var pushApplicationData = exports.pushApplicationData = function pushApplicationData(source, lang, auth, applicationId) {
  var applicationData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!applicationId && !applicationData)) {
                _context4.next = 2;
                break;
              }

              throw new TypeError('Application data is required when application ID is empty.');

            case 2:
              return _context4.abrupt('return', applicationId ? dispatch(updateApplication(source, lang, auth, applicationId, applicationData)) : dispatch(createApplication(source, lang, auth, applicationData)));

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, undefined);
    }));

    return function (_x10, _x11) {
      return _ref4.apply(this, arguments);
    };
  }();
};

/**
 * Dispatches an action to update the quote on the form, creating the application if necessary.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} applicationId - ID of the application to get a quote for. A new application will
 *                                 be created first if an empty value is given.
 * @param {Object} [applicationData=null] - Data to create an application with, if necessary.
 * @returns {Function} A thunk.
 */
var updateLiveQuote = exports.updateLiveQuote = function updateLiveQuote(context) {
  var applicationData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      var source, lang, auth, reqCount, response;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              source = context.props.formName;
              lang = context.props.params.language;
              auth = context.props.auth;
              reqCount = context.reqCount;
              _context5.next = 6;
              return dispatch(pushApplicationData(source, lang, auth, !context.state.showSaveQuote ? null : context.props.application.id, applicationData));

            case 6:
              response = _context5.sent;

              if (!(context.reqCount !== reqCount || response.error)) {
                _context5.next = 9;
                break;
              }

              return _context5.abrupt('return', dispatch(resetQuote({ data: response.payload })));

            case 9:
              return _context5.abrupt('return', dispatch(getApplicationQuote(source, lang, auth, response.payload.data.id)));

            case 10:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, undefined);
    }));

    return function (_x13, _x14) {
      return _ref5.apply(this, arguments);
    };
  }();
};

/**
 * Dispatches an action to update the quote on the form, creating the application if necessary.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} applicationId - ID of the application to get a quote for. A new application will
 *                                 be created first if an empty value is given.
 * @param {Object} [applicationData=null] - Data to create an application with, if necessary.
 * @returns {Function} A thunk.
 */
var saveQuoteNumber = exports.saveQuoteNumber = function saveQuoteNumber(source, lang, auth, applicationId) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return setLoadingState();
    },
    fetchResult: function fetchResult() {
      return Methods.get((0, _string.trimEnd)(_config2.default.api, '/') + '/savequote/' + source + '/' + applicationId, (0, _makeHeaders2.default)(lang, auth));
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? function () {} : getQuoteNumber(payload, true);
    }
  });
};

var returnQuoteNumber = exports.returnQuoteNumber = function returnQuoteNumber(source, lang, auth, applicationId) {
  return function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', dispatch(saveQuoteNumber(source, lang, auth, applicationId)));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, undefined);
    }));

    return function (_x15, _x16) {
      return _ref6.apply(this, arguments);
    };
  }();
};

/**
 * Dispatches an action to update the quote on the form, creating the application if necessary.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} applicationId - ID of the application to get a quote for. A new application will
 *                                 be created first if an empty value is given.
 * @param {Object} [applicationData=null] - Data to create an application with, if necessary.
 * @returns {Function} A thunk.
 */
var emailSavedQuote = exports.emailSavedQuote = function emailSavedQuote(source, lang, auth, applicationId, emails) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return setMailStatus();
    },
    fetchResult: function fetchResult() {
      return Methods.post((0, _string.trimEnd)(_config2.default.api, '/') + '/savedquote/' + source + '/' + applicationId, (0, _makeHeaders2.default)(lang, auth), emails);
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? EmailFailstatus() : EmailSentstatus();
    }
  });
};

var returnEmailSavedQuote = exports.returnEmailSavedQuote = function returnEmailSavedQuote(source, lang, auth, applicationId, emails) {
  return function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState) {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', dispatch(emailSavedQuote(source, lang, auth, applicationId, emails)));

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, undefined);
    }));

    return function (_x17, _x18) {
      return _ref7.apply(this, arguments);
    };
  }();
};

/**
 * Dispatches an action to get the failed payment details from the API.
 * @param {Object} auth - Authorization for the request.
 * @returns {Function} A thunk.
 */
var getPaymentDetails = exports.getPaymentDetails = function getPaymentDetails(paymentId, lang, auth) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return getFailedDetailsInit({ paymentId: paymentId });
    },
    fetchResult: function fetchResult() {
      return Methods.get((0, _string.trimEnd)(_config2.default.api, '/') + '/getFailedDetails/' + paymentId, (0, _makeHeaders2.default)(lang, auth));
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? getFailedDetailsComplete(payload, true) : getFailedDetailsComplete({ paymentId: paymentId, data: payload });
    }
  });
};

/**
 * Thunk action to process failed payments.
 * @param {Object} paymentMethod - The payment method details.
 * @param {string} applicationId - The ID of the application to process.
 * @param {Object} auth - Authorization token or credentials.
 * @returns {Function} A thunk.
 */
var processFailedPayments = exports.processFailedPayments = function processFailedPayments(paymentMethod, applicationId, auth, lang, source, data) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return processFailedPaymentsInit({ paymentMethod: paymentMethod, applicationId: applicationId, source: source });
    },

    fetchResult: function fetchResult() {
      return Methods.post((0, _string.trimEnd)(_config2.default.api, '/') + '/processFailedPayments/' + applicationId + '/' + source, (0, _makeHeaders2.default)(lang, auth), data);
    },

    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? processFailedPaymentsComplete(payload, true) : processFailedPaymentsComplete({ applicationId: applicationId, data: payload });
    }
  });
};

/**
 * Dispatches an action to submit contact form.
 * @param {String} lang - The app's language.
 * @returns {Function} A thunk.
 */
var submitContactForm = exports.submitContactForm = function submitContactForm(source, lang, auth, data) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return postContactFormInit();
    },
    fetchResult: function fetchResult() {
      return Methods.post((0, _string.trimEnd)(_config2.default.api, '/') + '/contactForm', (0, _makeHeaders2.default)(lang, auth), data);
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? postContactFormComplete(payload, true) : postContactFormComplete({ formSubmitted: true });
    }
  });
};

var resetContactForm = exports.resetContactForm = function resetContactForm() {
  return {
    type: Constants.RESET_CONTACT_FORM
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/actions/ActionCreators.js
// module id = 16
// module chunks = 0